import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function Confirmation(props) {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} centered>
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure you want to perform this action?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={props.onSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Confirmation;
